import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, Validators } from '@angular/forms';
import { ProfileService } from 'src/app/pages/account/services/profile.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ProfileTypeService } from 'src/app/core/services/profile-type-service.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { DomSanitizer } from '@angular/platform-browser';
import { ElementRef, ChangeDetectorRef } from '@angular/core';
import { UtilsService } from 'src/app/core/services/utils.service';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogOkComponent } from 'src/app/core/components/dialog-ok/dialog-ok.component';
import { LsHelperService } from 'src/app/core/services/ls-helper.service';
import { AccountService } from 'src/app/pages/account/services/account.service';
import { LookupService } from 'src/app/core/services/lookup.service';
import { DateUtils } from 'src/app/core/utils/date.utils';
export class TransactionAdminProfileModalComponent {
    constructor(dialogRef, data, formBuilder, profileService, matSnackBar, profileTypeService, authService, sanitizer, cdr, utilsService, translate, dialog, ls, accountService, lookupService) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.formBuilder = formBuilder;
        this.profileService = profileService;
        this.matSnackBar = matSnackBar;
        this.profileTypeService = profileTypeService;
        this.authService = authService;
        this.sanitizer = sanitizer;
        this.cdr = cdr;
        this.utilsService = utilsService;
        this.translate = translate;
        this.dialog = dialog;
        this.ls = ls;
        this.accountService = accountService;
        this.lookupService = lookupService;
        this.profile = null;
        this.profileTypes = [];
        this.profileImage = 'assets/images/avatars/profile.jpg';
        this.signatureImage = null; // Firma del solicitante (readonly)
        this.isLoading = true; // Estado de carga inicial
        this.isUpdating = false; // Estado de actualización (overlay)
        this.isCameraActive = false;
        this.isCapturingPhoto = false;
        this.isUploadingPhoto = false;
        this.isDestroyed = false;
        this.inches = Array.from({ length: 12 }, (_, i) => i);
        this.eyeColors = [
            { label: 'Azul', value: 'BLU' },
            { label: 'Verde', value: 'GRE' },
            { label: 'Marrón', value: 'BRW' },
            { label: 'Negro', value: 'BLK' },
            { label: 'Gris', value: 'GRY' },
            { label: 'Avellana', value: 'AVE' }
        ];
        // Opciones de género
        this.genderOptions = [
            { label: 'Masculino', value: 'Masculino' },
            { label: 'Femenino', value: 'Femenino' }
        ];
        this.profile = data;
        this.createForm();
        this.profileImage = 'assets/images/avatars/profile.jpg';
    }
    // Validador personalizado para fecha de nacimiento usando DateUtils
    static birthDateValidator(control) {
        let value = control.value;
        // Si está vacío o es null/undefined, no validar aquí (usar Validators.required para eso)
        if (!value) {
            return null;
        }
        // Limpiar el valor
        value = value.toString().trim().replace(/[_\s]+/g, '');
        // Si después de limpiar está vacío o incompleto, no validar
        if (value === '' || value.length < 10) {
            return null;
        }
        // Usar DateUtils para parsear y validar
        const parsed = DateUtils.parse(value, { debug: false, allowFuture: false });
        if (!parsed) {
            // Intentar determinar el tipo de error específico para mejor UX
            const dateRegex = /^(\d{1,2})[\/\-](\d{1,2})[\/\-](\d{4})$/;
            const match = value.match(dateRegex);
            if (!match) {
                return { invalidDate: true };
            }
            const part1 = parseInt(match[1], 10);
            const part2 = parseInt(match[2], 10);
            const year = parseInt(match[3], 10);
            // Detectar día y mes según el formato
            let day, month;
            if (part1 > 12) {
                day = part1;
                month = part2;
            }
            else if (part2 > 12) {
                month = part1;
                day = part2;
            }
            else {
                day = part1;
                month = part2;
            }
            if (day < 1 || day > 31) {
                return { invalidDay: true };
            }
            if (month < 1 || month > 12) {
                return { invalidMonth: true };
            }
            if (year < 1800 || year > new Date().getFullYear()) {
                return { invalidYear: true };
            }
            // Si llegamos aquí, la fecha no existe en el calendario (ej: 31/02)
            // o es una fecha futura
            const testDate = new Date(year, month - 1, day);
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            if (testDate > today) {
                return { futureDate: true };
            }
            return { invalidDate: true };
        }
        return null;
    }
    ngOnInit() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.isLoading = true;
            try {
                // Cargar lookups primero para que los selects de ciudad/país funcionen
                if (this.lookupService.cities.length === 0) {
                    yield this.lookupService.getLookups();
                }
                // Cargar tipos de perfil, imagen y firma en paralelo
                yield Promise.all([
                    this.getProfileTypes(),
                    this.loadProfileImage(this.profile.PhotoIdFileName),
                    this.loadSignatureImage()
                ]);
            }
            finally {
                this.isLoading = false;
                this.cdr.detectChanges();
            }
        });
    }
    loadProfileImage(fileName) {
        return new Promise((resolve) => {
            this.profileImage = null;
            if (fileName) {
                this.authService.getFileByFileName(fileName, false).then((base64) => {
                    this.profileImage = base64;
                    resolve();
                }).catch((error) => {
                    this.profileImage = 'assets/images/avatars/profile.jpg';
                    resolve();
                });
            }
            else {
                this.profileImage = 'assets/images/avatars/profile.jpg';
                resolve();
            }
        });
    }
    loadSignatureImage() {
        return new Promise((resolve) => {
            this.signatureImage = null;
            if (this.profile && this.profile.Id) {
                this.profileService.getSignature(this.profile.Id).then((response) => {
                    if (response && response.Data) {
                        // La respuesta puede ser base64 directo o un objeto con la propiedad Signature
                        const signatureData = response.Data.Signature || response.Data;
                        if (signatureData && typeof signatureData === 'string' && signatureData.length > 0) {
                            // Verificar si ya tiene el prefijo data:image
                            if (signatureData.startsWith('data:image')) {
                                this.signatureImage = signatureData;
                            }
                            else {
                                // Agregar el prefijo si es solo base64
                                this.signatureImage = `data:image/png;base64,${signatureData}`;
                            }
                        }
                    }
                    resolve();
                }).catch((error) => {
                    console.log('No se pudo cargar la firma del perfil:', error);
                    this.signatureImage = null;
                    resolve();
                });
            }
            else {
                resolve();
            }
        });
    }
    getProfileTypes() {
        return new Promise((resolve, reject) => {
            // Cargar tipos de perfil
            this.profileTypeService.getProfileTypes().subscribe((res) => {
                this.profileTypes = this.profile.IsIndividual ? res.Data.profileTypeIndividual : res.Data.profileTypeEntity;
                this.patchForm();
                resolve();
            }, (error) => {
                console.error('Error loading profile types', error);
                this.patchForm(); // Patch form anyway to show the data we have
                resolve();
            });
        });
    }
    createForm() {
        if (this.profile.IsIndividual) {
            this.form = this.formBuilder.group({
                IsIndividual: [true],
                Name: ['', Validators.required],
                SecondName: [''],
                LastName: ['', Validators.required],
                SecondLastName: [''],
                ProfileTypeId: ['00000000-0000-0000-0000-000000000000', Validators.required],
                Address: [null],
                Street1: [null],
                Street2: [null],
                CityId: [null],
                State: [null],
                PostalCode: [null],
                OtherStreet1: [null],
                OtherStreet2: [null],
                OtherCityId: [null],
                OtherState: [null],
                OtherPostalCode: [null],
                CountryId: [null],
                OtherCountryId: [null],
                Weight: [null],
                EyeColor: [null],
                Gender: [null],
                HeightFeet: [null],
                HeightInches: [null],
                BirthDate: [null, [TransactionAdminProfileModalComponent.birthDateValidator]],
            });
        }
        else {
            this.form = this.formBuilder.group({
                IsIndividual: [false],
                Name: ['', Validators.required],
                ProfileTypeId: ['00000000-0000-0000-0000-000000000000', Validators.required],
                Address: [null],
                Street1: [null],
                Street2: [null],
                CityId: [null],
                State: [null],
                PostalCode: [null],
                OtherStreet1: [null],
                OtherStreet2: [null],
                OtherCityId: [null],
                OtherState: [null],
                OtherPostalCode: [null],
                CountryId: [null],
                OtherCountryId: [null],
                Weight: [null],
                EyeColor: [null],
                Gender: [null],
                HeightFeet: [null],
                HeightInches: [null],
                BirthDate: [null, [TransactionAdminProfileModalComponent.birthDateValidator]],
            });
        }
    }
    patchForm() {
        // Normalizar cityId para que coincida con los valores del lookup
        const normalizeCityId = (cityId) => {
            if (!cityId)
                return '';
            const cityIdStr = cityId.toString().trim();
            // Si ya es un número, verificar que existe en el lookup
            if (/^\d+$/.test(cityIdStr)) {
                const exists = this.lookupService.cities.find(c => c.value === cityIdStr);
                if (exists)
                    return cityIdStr;
            }
            // Si es un nombre de ciudad, buscar el ID
            const normalize = (s) => (s || '').toString().normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase().trim();
            const match = this.lookupService.cities.find(c => normalize(c.label) === normalize(cityIdStr));
            return match ? match.value : cityIdStr;
        };
        const address = {
            StreetAddress: this.profile.Street1,
            StreetAddress2: this.profile.Street2,
            MunicipioStreet: normalizeCityId(this.profile.CityId),
            PostalCode: this.profile.PostalCode,
            PostPlusFour1: '',
            PostalAddress: this.profile.OtherStreet1,
            PostalAddress2: this.profile.OtherStreet2,
            MunicipioPostal: normalizeCityId(this.profile.OtherCityId),
            PPostalCode: this.profile.OtherPostalCode,
            PostPlusFour2: '',
            postalAsStreet: this.profile.Street1 === this.profile.OtherStreet1 ? true : false,
            State: this.profile.State ? this.profile.State.toString() : '',
            StatePostal: this.profile.OtherState ? this.profile.OtherState.toString() : '',
            // '376' es Puerto Rico - valor por defecto si no hay CountryId
            Country: this.profile.CountryId ? this.profile.CountryId.toString() : '376',
            CountryPostal: this.profile.OtherCountryId ? this.profile.OtherCountryId.toString() : '376'
        };
        // Transformar Gender del backend (M/F) al formulario (Masculino/Femenino)
        const normalizeGender = (gender) => {
            if (!gender)
                return '';
            if (gender === 'M')
                return 'Masculino';
            if (gender === 'F')
                return 'Femenino';
            return gender; // Si ya está en formato largo, devolverlo tal cual
        };
        if (this.profile.IsIndividual) {
            console.log('[patchForm] BirthDate del backend:', this.profile.BirthDate);
            const formattedBirthDate = this.profile.BirthDate ? this.formatDateFromISOmmddyyyy(this.profile.BirthDate) : null;
            console.log('[patchForm] BirthDate formateado para UI:', formattedBirthDate);
            this.form.patchValue({
                IsIndividual: this.profile.IsIndividual,
                Name: this.profile.Name,
                SecondName: this.profile.SecondName,
                LastName: this.profile.LastName,
                SecondLastName: this.profile.SecondLastName,
                Address: address,
                ProfileTypeId: '00000000-0000-0000-0000-000000000000',
                Weight: this.profile.Weight,
                EyeColor: this.profile.EyeColor,
                Gender: normalizeGender(this.profile.Gender),
                HeightFeet: this.profile.HeightFeet,
                HeightInches: this.profile.HeightInches,
                BirthDate: formattedBirthDate,
            });
        }
        else {
            this.form.patchValue({
                IsIndividual: this.profile.IsIndividual,
                Name: this.profile.Name,
                Address: address,
                ProfileTypeId: '00000000-0000-0000-0000-000000000000',
                Weight: this.profile.Weight,
                EyeColor: this.profile.EyeColor,
                Gender: normalizeGender(this.profile.Gender),
                HeightFeet: this.profile.HeightFeet,
                HeightInches: this.profile.HeightInches,
                BirthDate: this.profile.BirthDate ? this.formatDateFromISOmmddyyyy(this.profile.BirthDate) : null,
            });
        }
        // Forzar detección de cambios para que el *ngIf del municipio se actualice
        setTimeout(() => {
            this.cdr.detectChanges();
        }, 0);
    }
    closeDialog() {
        this.dialogRef.close();
    }
    updateProfile() {
        // Validar el formulario antes de actualizar
        if (this.form.invalid) {
            // Marcar todos los controles como touched para mostrar los errores
            Object.keys(this.form.controls).forEach(key => {
                this.form.get(key).markAsTouched();
            });
            return;
        }
        // Mostrar overlay de carga
        this.isUpdating = true;
        const data = this.form.value;
        data.Street1 = data.Address.StreetAddress;
        data.Street2 = data.Address.StreetAddress2;
        data.CityId = data.Address.MunicipioStreet;
        data.State = data.Address.State;
        data.PostalCode = data.Address.PostalCode;
        data.OtherStreet1 = data.Address.PostalAddress;
        data.OtherStreet2 = data.Address.PostalAddress2;
        data.OtherCityId = data.Address.MunicipioPostal;
        data.OtherState = data.Address.StatePostal;
        data.OtherPostalCode = data.Address.PPostalCode;
        data.CountryId = data.Address.Country;
        data.OtherCountryId = data.Address.CountryPostal;
        if (data.BirthDate) {
            console.log('[updateProfile] BirthDate original del formulario:', data.BirthDate);
            const isoDate = this.formatDateToISO(data.BirthDate);
            if (isoDate) {
                data.BirthDate = isoDate;
                console.log('[updateProfile] BirthDate convertido a ISO:', data.BirthDate);
            }
            else {
                console.warn('[updateProfile] No se pudo convertir BirthDate, manteniendo valor original');
                // Si no se puede convertir, mantener el valor original del perfil
                data.BirthDate = this.profile.BirthDate;
            }
        }
        // Transformar Gender del formulario (Masculino/Femenino) al backend (M/F)
        if (data.Gender) {
            data.Gender = data.Gender === 'Masculino' ? 'M' : 'F';
        }
        this.profile = Object.assign({}, this.profile, data);
        this.profileService
            .updateV2(this.profile)
            .then((response) => {
            this.isUpdating = false;
            if (response.Success) {
                this.matSnackBar.open('Perfil actualizado correctamente', 'Cerrar', { duration: 3000 });
            }
            else {
                this.matSnackBar.open(response.Message || 'Error al actualizar el perfil', 'Cerrar', { duration: 3000 });
            }
        }, err => {
            this.isUpdating = false;
            console.error('Error updating profile:', err);
            this.matSnackBar.open('Error al actualizar el perfil', 'Cerrar', { duration: 3000 });
        });
    }
    // Camera functionality methods
    openCamera() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                // Request camera access
                this.stream = yield navigator.mediaDevices.getUserMedia({
                    video: {
                        width: { ideal: 640 },
                        height: { ideal: 480 },
                        facingMode: 'user' // Use front camera
                    }
                });
                // Show video element and start stream
                this.videoElement.nativeElement.srcObject = this.stream;
                this.videoElement.nativeElement.style.display = 'block';
                this.videoElement.nativeElement.hidden = false;
                this.isCameraActive = true;
                // Show capture button
                this.showCameraControls();
            }
            catch (error) {
                console.error('Error accessing camera:', error);
                // Siempre usar modo simulación en desarrollo
                this.simulateCamera();
            }
        });
    }
    showCameraControls() {
        // Camera controls are now handled by Angular template with *ngIf="isCameraActive"
        // No need to create dynamic HTML since we're using Angular Material buttons
    }
    simulateCamera() {
        // Crear un canvas con imagen simulada
        const canvas = document.createElement('canvas');
        canvas.width = 640;
        canvas.height = 480;
        const ctx = canvas.getContext('2d');
        // Dibujar fondo del color primario
        ctx.fillStyle = '#132F5C'; // $color-primary
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        // Agregar texto
        ctx.fillStyle = 'white';
        ctx.font = '24px Arial';
        ctx.textAlign = 'center';
        ctx.fillText('Cámara Simulada', canvas.width / 2, canvas.height / 2 - 20);
        ctx.font = '16px Arial';
        ctx.fillText('Modo Desarrollo', canvas.width / 2, canvas.height / 2 + 10);
        ctx.fillText('Haz clic en "Capturar Foto"', canvas.width / 2, canvas.height / 2 + 40);
        // En lugar de usar captureStream, creamos una imagen estática
        // y la mostramos directamente en el video element
        const imageDataUrl = canvas.toDataURL('image/jpeg', 0.8);
        // Crear un video element temporal para simular el stream
        const tempVideo = document.createElement('video');
        tempVideo.src = imageDataUrl;
        tempVideo.loop = true;
        tempVideo.muted = true;
        tempVideo.autoplay = true;
        // Mostrar el canvas directamente en lugar del video
        this.videoElement.nativeElement.style.display = 'none';
        this.videoElement.nativeElement.hidden = true;
        // Mostrar el canvas como "video"
        const canvasElement = this.canvasElement.nativeElement;
        canvasElement.style.display = 'block';
        canvasElement.hidden = false;
        canvasElement.width = 640;
        canvasElement.height = 480;
        // Copiar el contenido del canvas temporal al canvas del componente
        const canvasCtx = canvasElement.getContext('2d');
        canvasCtx.drawImage(canvas, 0, 0);
        this.isCameraActive = true;
        this.showCameraControls();
    }
    capturePhoto() {
        if (!this.canvasElement) {
            return;
        }
        // Activar estado de carga
        this.isCapturingPhoto = true;
        console.log('isCapturingPhoto set to true - starting photo capture');
        const canvas = this.canvasElement.nativeElement;
        // Si estamos en modo simulación, el canvas ya tiene la imagen
        // Si estamos en modo real, capturamos del video
        if (this.isCameraActive && this.videoElement && this.videoElement.nativeElement.srcObject) {
            // Modo real: capturar del video
            const video = this.videoElement.nativeElement;
            const context = canvas.getContext('2d');
            // Set canvas size to match video
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            // Draw video frame to canvas
            context.drawImage(video, 0, 0, canvas.width, canvas.height);
        }
        // En modo simulación, el canvas ya tiene la imagen correcta
        // Convert canvas to blob
        canvas.toBlob((blob) => {
            if (blob) {
                // Create file from blob
                const file = new File([blob], 'camera-photo.jpg', { type: 'image/jpeg' });
                // Upload the captured photo
                this.upload([file]);
                // No cerrar la cámara aquí, se cerrará después de la subida exitosa
            }
            else {
                // Si hay error al crear el blob, desactivar estado de carga
                this.isCapturingPhoto = false;
            }
        }, 'image/jpeg', 0.8);
    }
    closeCamera() {
        if (this.stream) {
            // Stop all tracks
            this.stream.getTracks().forEach(track => track.stop());
            this.stream = null;
        }
        // Hide video element
        if (this.videoElement) {
            this.videoElement.nativeElement.style.display = 'none';
            this.videoElement.nativeElement.hidden = true;
        }
        // Hide canvas element
        if (this.canvasElement) {
            this.canvasElement.nativeElement.style.display = 'none';
            this.canvasElement.nativeElement.hidden = true;
        }
        // Reset camera states
        this.isCameraActive = false;
        this.isCapturingPhoto = false;
        // Forzar la detección de cambios
        if (!this.isDestroyed) {
            try {
                this.cdr.detectChanges();
            }
            catch (error) {
                // Ignorar errores si la vista ya fue destruida
                console.log('View already destroyed, skipping detectChanges');
            }
        }
    }
    upload(files, uploadingPhoto = false) {
        if (uploadingPhoto) {
            this.isUploadingPhoto = true;
        }
        if (files.length === 0) {
            return;
        }
        const isValid = this.utilsService.verifyFileExtension(files[0].name);
        if (isValid) {
            this.uploadAndProgress(files);
        }
        else {
            this.translate.get(['error.invalidExtension'])
                .subscribe(translations => {
                this.dialog.open(DialogOkComponent, {
                    data: {
                        msg: translations['error.invalidExtension']
                    }
                });
            });
            return;
        }
    }
    uploadAndProgress(files) {
        const formData = new FormData();
        Array.from(files).forEach(f => formData.append('file', f));
        this.profileService.uploadImage(formData, this.profile.Id)
            .then((uploadedImage) => {
            // Recargar la imagen usando el nuevo método
            this.loadProfileImage(uploadedImage);
            // Cerrar la cámara y limpiar estados
            this.closeCamera();
            // Forzar la detección de cambios para asegurar que la UI se actualice
            this.cdr.detectChanges();
            this.isUploadingPhoto = false;
            this.isCapturingPhoto = false;
        }, err => {
            this.isUploadingPhoto = false;
            this.isCapturingPhoto = false;
        });
    }
    // Métodos de fecha usando DateUtils (reutilizable en toda la aplicación)
    formatDateToISO(date) {
        return DateUtils.toISO(date);
    }
    formatDateToDisplay(date) {
        return DateUtils.toDisplay(date);
    }
    formatDateFromISO(date) {
        return DateUtils.toDisplay(date);
    }
    formatDateFromISOmmddyyyy(date) {
        return DateUtils.toDisplay(date);
    }
}
